import React from "react";

const ContentLoader = () => {
  return (
    <>
      <center className="mb-5 mt-5">
        <div
          class="spinner-border text-warning"
          role="status"
          style={{ height: 50, width: 50 }}
        >
          <span class="sr-only">Loading...</span>
        </div>
      </center>
    </>
  );
};

export default ContentLoader;
